import { Service } from '@roc/feature-app-core';

const url = {
  GET_IS_COGS_ONLINE:
    '/api/v1/loan/cogs/getIsCogsOnline',
};

export class CogsService extends Service {
  getIsCogsOnline = (loanId: number) => {
    return this.get(url.GET_IS_COGS_ONLINE, {loanId});
  }
}